import axios from 'axios';
import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { useOutletContext } from 'react-router-dom';
import IResponse from '../../interfaces/response';
import CarType from '../../interfaces/car';
import { TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
export default function LicensePlateSearch() {
	const {t} = useTranslation();
	const { setCars, page, setPage, setLoading, setTotalPage, loading } = useOutletContext<{
		setCars: Dispatch<SetStateAction<CarType[]>>,
		page: number,
		loading: boolean,
		setPage: Dispatch<SetStateAction<number>>,
		setLoading: Dispatch<SetStateAction<boolean>>,
		setTotalPage: Dispatch<SetStateAction<number>>,
	}>();
	const iranCodeRef = useRef<HTMLInputElement>(null);
	const licensePlateRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		setLoading(false);
	}, [])

	const handleSearch = () => {
		setLoading(true);
		setPage(1);
		axios<IResponse<CarType[]>>({
			url: '/car/chassis',
			params: {
				page,
				license_plate_iran_code: iranCodeRef.current?.value,
				license_plate: licensePlateRef.current?.value,
			}
		}).then(res => {
			if (res.data.success) {
				setCars(res.data.data)
				setTotalPage(res.data.pagination?.totalPages ?? 0)
			}
		}).finally(() => {
			setLoading(false);
		})
	}
	return (
		<div className='flex flex-row gap-4 w-full mb-9 bg-primary-hover rounded-lg p-8 items-center'>
			<Typography>{t('license_plate_number')}: </Typography>
			<TextField className='w-16' size='small' inputRef={iranCodeRef}/>
			<Typography>{t('iran')}</Typography>
			<TextField size='small' inputRef={licensePlateRef}/>
			<LoadingButton className='mx-10 px-10' variant='contained' onClick={handleSearch} loading={loading}>{t("search")}</LoadingButton>
		</div>
	)
}
